export * from './copy';

/** 异步函数重试 */
export async function retryAsync<T>(
  fn: (attempt: number) => Promise<T>,
  options?: {
    retries?: number;
    delay?: number;
    factor?: number;
    shouldRetry?: (error: unknown) => boolean;
    onFinish?: (attempts: number, error?: unknown) => void;
  },
): Promise<T> {
  const { retries = 3, delay = 500, factor = 2, shouldRetry, onFinish } = options || {};
  let lastError: unknown;
  let currentDelay = delay;
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const result = await fn(attempt);
      onFinish?.(attempt + 1);
      return result;
    } catch (err) {
      lastError = err;

      // 如果提供了 shouldRetry 且判断不应重试，直接抛出错误
      if (shouldRetry && !shouldRetry(err)) {
        onFinish?.(attempt + 1, err);
        throw err;
      }

      if (attempt < retries - 1) {
        await new Promise(res => setTimeout(res, currentDelay));
        currentDelay *= factor;
      }
    }
  }
  onFinish?.(retries, lastError);
  throw lastError;
}

export function isBlobURL(str: string) {
  try {
    const urlObj = new URL(str);
    return urlObj.protocol === 'blob:';
  } catch {
    return false; // 解析失败，不是合法的URL
  }
}
